var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"noDatabox"},[_c('p',[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }